import _ from 'lodash';

const stringsToNodes = (html) => {
  const template = document.createElement('template');
  template.innerHTML = html;
  return template.content.children;
};

const isAbsoluteUrl = (src) => {
  const absCheck = new RegExp('//');
  return absCheck.test(src);
};

const getImageNodes = (elmNodes) => {
  return _(elmNodes)
    .map((elmNode) => {
      return [
        elmNode.tagName === 'IMG' ? elmNode : Array.from(elmNode.querySelectorAll("img"))
      ];
    })
    .flatten()
    .value();
};

const removeRelativeUrls = (imgNodes) => {
  imgNodes.forEach((img) => {
    if (!isAbsoluteUrl(img.getAttribute('src'))) {
      img.remove();
    }
  });
};

export default function sanitizeSource(html) {
  const elmNodes = stringsToNodes(html);
  removeRelativeUrls(getImageNodes(elmNodes));
  return _.map(elmNodes, (node) => {
    return node.outerHTML;
  }).join('');
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/img-cleaner.js